import React, {Component} from "react";
import AboutComponentOpenData from "../../../components/open_data/beranda/AboutComponentOpenData";

export class AboutOpenData extends Component{
    render(){
        return(
            <AboutComponentOpenData />
        )
    }
}

export default AboutOpenData;